import React from 'react';
import { Helmet } from 'react-helmet';

export default function AskACandidateInfo(props){
  return (
    <div>
        <Helmet>
                <title>Ask a Candidate | icitizen</title>
                <meta name="title" content={`Chatbot Info | icitizen`}/>
                <meta name="description" content="Information on icitizen chatbots"/>
                <meta property="og:type" content="website"/>
                <meta property="og:url" content={window.location.href}/>
                <meta property="og:title" content={`Chatbot Info | icitizen`}/>
                <meta property="og:description" content="Information on icitizen chatbots"/>
                <meta property="og:image" content="https://icitizen.com/ic_card.png"/>
                <meta property="twitter:card" content="summary_large_image"/>
                <meta property="twitter:url" content={window.location.href}/>
                <meta property="twitter:title" content={`Chatbot Info | icitizen`}/>
                <meta property="twitter:description" content="Information on icitizen chatbots"/>
                <meta property="twitter:image" content="https://icitizen.com/ic_card.png"/>
        </Helmet>
        <h2>Candidate Chatbots</h2>
        <p>Candidate Chatbots allow users to chat with AI representations of candidates in the upcoming presidential election.
        </p>
        <p>
            The responses are generated with the GPT-3.5 LLM, with various information on the candidates
            passed in as context, including biographies, speeches, political positions, and social media posts.
        </p>
        <p>
            Currently, each user is allotted 25 chats per day.
        </p>
        <p>
          Contact <a href="team@icitizen.com">team@icitizen.com</a> to increase your daily chat quota for a small fee.
        </p>
        </div>
  );
};